/* Copyright 2016-2021
   Kabandy
   Author: Cedric Hoarau
 */

export module ApiDataModel {
    export interface IWorkspace {
        id: string;
        name: string;
        created_at: string;
        updated_at: string;
    }

    export interface IModel {
        id: string;
        workspaceId: string;
        modelfilesIds: string[];
        name: string;
        created_at: string;
        updated_at: string;
    }

    export interface IModelfile {
        id: string;
        workspaceId: string;
        modelId: string;
        versionIds: string[];
        created_at: string;
    }

    export interface IVersion {
        id: string;
        workspaceId: string;
        modelId: string;
        modelfileId: string;
        filename: string;
        fileSize: string;
        created_at: string;
        updated_at: string;
    }

    export enum EVersionStatusValue {
        Pending = "PENDING",
        Executing = "EXECUTING",
        Success = "SUCCESS",
        Error = "ERROR"
    }
    export interface IVersionStatus {
        id: string;
        workspaceId: string;
        versionId: string;
        value: EVersionStatusValue;
    }

    export interface IQuantity {
        id: string;
        workspaceId: string;
        modelId: string;
        versionIds: string[];
        type: "measure" | "viewpoint";
        value: number;
        multiplier: number;
        unit: "object" | "length" | "surface" | "volume" | "percentdesc" | "masskg" | "durationday" | "euro" | "";
        measureType: "object" | "length" | "surface" | "volume" | "";
        created_at: string;
    }

    export enum EErrorMsg {
        ActivateUserAccess = "Can't activate access"
    }
    export enum EErrorReason {
        AccessNotFound = "Access not found",
        ContractMaxConcurrentAccessesCountReached = "Maximum of concurrent accesses has been reached"
    }

    export interface IBoard {
        id: string;
        workspaceId: string;
        name: string;
        created_at: string;
        updated_at: string;
    }
    export interface IBoardSection {
        id: string;
        name: string;
        created_at: string;
        updated_at: string;
    }
    export interface IBoardGroup {
        id: string;
        sectionId: string;
        name: string;
        created_at: string;
        updated_at: string;
    }
    export interface IBoardItem {
        id: string;
        sectionId: string;
        groupId: string;
        name: string;
        created_at: string;
        updated_at: string;
    }
    export interface IBoardProperty {
        id: string;
        name: string;
        type: EBoardCellType;
        created_at: string;
        updated_at: string;
    }
    export interface IBoardCell {
        id: string;
        itemId: string;
        propertyId: string;
        type: EBoardCellType;
        created_at: string;
        updated_at: string;
    }
    export enum EBoardCellType {
        Measure = "MEASURE",
        Text = "TEXT",
        Viewpoint = "VIEWPOINT"
    } 
    export interface IBoardCellMeasure extends IBoardCell {
        measureId: string;
        value: number;
        unit: "object" | "length" | "surface" | "volume" | "percentdesc" | "masskg" | "durationday" | "euro" | "";
        multiplier: number;
        measureType: "object" | "length" | "surface" | "volume" | "";
    }
    export interface IBoardCellViewpoint extends IBoardCell {
        viewpointId: string;
    }
    export interface IBoardCellText extends IBoardCell {
        value: string
    }
    export enum EBoardStatusValue {
        Pending = "PENDING",
        Executing = "EXECUTING",
        Success = "SUCCESS",
        Error = "ERROR"
    }
    export interface IBoardStatus {
        id: string;
        workspaceId: string;
        boardId: string;
        value: EBoardStatusValue;
    }
}

export module ApiRequestBody {
    export module Quantity {
        export interface IPost {
            quantityType: "measure" | "viewpoint";
            content?: any;
            selectionMethodBitmask?: number,
            filtersTmpUuid?: string;
            selectionTmpUuid?: string;
            autoselectsTmpUuid?: string;
            snapshotTmpUuid?: string;
            customPropertiesTmpUuid?: string;
            nonGuidMeasureTmpUuid?: string;
        }
    }

    export module Board {
        export interface IPost {
            name: string;
        }
        export interface IPut {
            name: string;
        }
    }
}
